export default __webpack_public_path__ + "static/media/port-pvn.1ff5c9da.webp";